var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2.91802C9.82691 2.91802 8.05887 4.68606 8.05887 6.85928C8.05887 9.03249 9.82691 10.8005 12.0001 10.8005C14.1733 10.8005 15.9414 9.03249 15.9414 6.85928C15.9414 4.68606 14.1733 2.91802 12.0001 2.91802ZM8.40124 14.4858C6.08628 14.4858 4.20293 16.3692 4.20293 18.6842V20.3551C4.20293 20.7565 4.5295 21.083 4.9309 21.083H19.0693C19.4707 21.083 19.7973 20.7565 19.7973 20.3551V18.6842C19.7973 16.3692 17.914 14.4858 15.599 14.4858H15.1803C14.1672 14.9124 13.0987 15.1285 12.0001 15.1285C10.9054 15.1285 9.83724 14.9124 8.82087 14.4858H8.40124ZM12.0001 1.71802C14.8399 1.71802 17.1414 4.01954 17.1414 6.85928C17.1414 9.69901 14.8399 12.0005 12.0001 12.0005C9.16038 12.0005 6.85887 9.69901 6.85887 6.85928C6.85887 4.01954 9.16038 1.71802 12.0001 1.71802ZM8.40124 13.2858H9.07202C9.96772 13.6955 10.9558 13.9285 12.0001 13.9285C13.0444 13.9285 14.0365 13.6955 14.9282 13.2858H15.599C18.5793 13.2858 20.9973 15.7038 20.9973 18.6842V20.3551C20.9973 21.4195 20.1337 22.283 19.0693 22.283H4.9309C3.8665 22.283 3.00293 21.4195 3.00293 20.3551V18.6842C3.00293 15.7038 5.42092 13.2858 8.40124 13.2858Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame6);
export default __webpack_public_path__ + "static/media/Frame (6).740cb6a2.svg";
export { ForwardRef as ReactComponent };